var treeCard = {
    base: {
        "--line-box-width": "24px",
        "--card-margin-top": "8px",
        font: "md",
        "ul:focus, li:focus": {
            outline: "none",
        },
        'ul[role="tree"]': {
            boxSizing: "border-box",
            listStyle: "none",
            p: 0,
            m: 0,
        },
        'ul[role="group"]': {
            listStyle: "none",
            boxSizing: "border-box",
            p: 0,
        },
        'li[role="treeitem"]:not([data-first-node])': {
            marginTop: "8px",
        },
    },
    variants: {
        size: {
            sm: {
                "--icon-box-size": "26px",
                "--card-padding": "4px",
            },
            md: {
                "--icon-box-size": "33px",
                "--card-padding": "6px",
            },
            lg: {
                "--icon-box-size": "44px",
                "--card-padding": "8px",
            },
        },
    },
    variantOrder: ["size"],
    defaultProps: {
        size: "md",
    },
};
var treeCardContent = {
    base: {
        display: "grid",
        font: "body",
        width: "100%",
        bg: "white",
        borderRadius: 3,
        borderWidth: "1px",
        borderColor: "black.20",
        borderStyle: "solid",
        '&[data-has-children="true"][data-is-active="false"]:hover': {
            cursor: "pointer",
            boxShadow: 2,
        },
        '&[data-is-active="true"]': {
            boxShadow: "0 0 0 4px var(--colors-focus-shadow)",
        },
        p: "var(--card-padding)",
        zIndex: "base", // was 1, do we need that?
    },
};

export { treeCard, treeCardContent };
//# sourceMappingURL=tree-card.js.map
